<i18n>
zh:
    message: 在线留言
    name: 姓名
    address: 地点
    type: 信件类别
    subject: 信件主题
    content: 信件内容
    submit: 提交
    typeData: ["建议", "求助", "投诉", "咨询", "其他"]
ru:
    message: Оставьте сообщение
    name: им
    address: мест
    type: Категория писем
    subject: Тема письма
    content: Содержание письма
    submit: представ
    typeData: ["Рекомендации", "помощь", "жалобы", "консультации", "другие"]
</i18n>
<template>
    <div class="message">
        <div class="title_en">Online Message</div>
        <div class="content_title">{{$t('message')}}</div>
        <div class="form">
            <div class="item">
                <div class="title">{{$t('name')}}</div>
                <input type="text" v-model="form.name" />
            </div>
            <div class="item">
                <div class="title">{{$t('address')}}</div>
                <input type="text" v-model="form.address" />
            </div>
            <div class="item required">
                <div class="title">{{$t('type')}}</div>
                <select v-model="form.type">
                    <option v-for="(item, index) in $t('typeData')" :key="item" :value="parseInt(index) + 1">{{item}}</option>
                </select>
            </div>
            <div class="item">
                <div class="title">{{$t('subject')}}</div>
                <input type="text" v-model="form.theme" />
            </div>
            <div class="item required">
                <div class="title">{{$t('content')}}</div>
                <textarea type="text" v-model="form.content" />
            </div>
            <div class="btn" @click="submit">{{$t('submit')}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "message",
    data() {
        return {
            // type: ['建议', '求助', '投诉', '咨询', '其他'],
            form: {
                name: '',
                address: '',
                type: '1',
                theme: '',
                content: '',
            }
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        '$route.params.id': {
            handler: 'getData',
            immediate: true
        }
    },
    methods: {
        getData(val){
            this.$store.dispatch('getRepair', {id: val});
        },
        submit(){
            if(this.form.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$showToast({
                    text: '信件内容不能为空'
                })
                return false;
            }
            this.$showLoading();
            this.$store.dispatch('upMessage', this.form).then((result)=>{
                this.$hideLoading();
                this.form = {
                    name: '',
                    address: '',
                    type: '建议',
                    theme: '',
                    content: '',
                }
                this.$showToast({
                    text: '提交成功'
                })
            });
        }
    },
};
</script>

<style scoped lang="scss">
.message{
    width: 910px;
    margin-left: 56px;
    background: #fff;
    padding: 0 0 20px 45px;
    .content_title{
        background-image: url('~@/assets/images/1_18.png');
        padding-left: 35px;
        margin: 20px 0;
        border: none;
        font-size: 24px;
    }
    .title_en{
        font-family: "宋体";
        font-weight: bold;
        font-size: 46px;
        color: #dce1e5;
        margin-top: 30px;
    }
    .form{
        padding-right: 45px;
        .item{
            display: flex;
            margin-bottom: 20px;
            font-size: 14px;
            position: relative;
            &.required{
                &::before{
                    content: '*';
                    position: absolute;
                    right: calc(100% + 5px);
                    top: 0;
                    height: 30px;
                    line-height: 30px;
                }
            }
            .title{
                width: 100px;
                height: 30px;
                // line-height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f1f1f1;
                color: #999;
                text-align: center;
                margin-right: 20px;
            }
            select,
            textarea,
            input{
                margin: 0;
                padding: 0;
                border: none;
                background: none;
                outline: none;
                font-family: Arial, Helvetica, sans-serif, '宋体', "Microsoft YaHei";
                box-sizing: border-box;
                
                flex: 1;
                border: 1px solid #f1f1f1;
                font-size: 14px;
                padding: 0 10px;
            }
            textarea{
                padding: 5px 10px;
                height: 100px;
                resize: none;
            }
        }
        .btn{
            width: 150px;
            color: #fff;
            background: #fdaf40;
            border-radius: 5px;
            line-height: 2;
            text-align: center;
            margin-left: 120px;
            cursor: pointer;
        }
    }
    @media only screen and (max-width: 1024px) {
        width: 100%;
        margin: 0;
        padding: 0;
        .content_title{
            background: none;
            margin: 0;
            padding: 0;
            font-size: .36rem;
            margin-bottom: .3rem;
        }
        .title_en{
            display: none;
        }
        .form{
            padding-right: 0;
            .item{
                display: block;
                margin-bottom: .4rem;
                .title{
                    width: 100%;
                    height: auto;
                    background: none;
                    display: block;
                    text-align: left;
                    color: #000;
                    margin-bottom: .1rem;
                    font-size: .3rem;
                }
                select,
                textarea,
                input{
                    width: 100%;
                    height: .6rem;
                    font-size: .3rem;
                    border-radius: .1rem;
                }
                textarea{
                    height: 2rem;
                }
            }
            .btn{
                margin: 0 auto;
            }
        }
    }
}
</style>